import { render, staticRenderFns } from "./personForm.vue?vue&type=template&id=4142e699&scoped=true&"
import script from "./personForm.vue?vue&type=script&lang=js&"
export * from "./personForm.vue?vue&type=script&lang=js&"
import style0 from "./personForm.vue?vue&type=style&index=0&id=4142e699&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4142e699",
  null
  
)

export default component.exports